import React from "react";
import { getInstantValidationState } from '../../../utils/realTimeValidationUtils';

import './SANE.scss';

const SANE = ({ handleFormData, study, values, fieldErrors = {}, touchedFields = {} }) => {
  // Get instant validation state for real-time feedback
  const validationState = getInstantValidationState('saneScore', fieldErrors, touchedFields, values.saneScore);

  return (
    <div className="modern-assessment">
      <h2 className="assessment-title">SANE Score</h2>
      <div className={validationState.formGroupClasses}>
        <label className="modern-form-label required">
          1. Hoe zou u vandaag uw {study === "elbow"? "elleboog" : "schouder"} beoordelen op een schaal van 0 tot 100?
        </label>
        <p className="modern-form-help">
          Waarbij 100 uw normale functieniveau is en 0 niet in staat is om te functioneren
        </p>
        <div className={validationState.inputClasses('modern-pain-slider')}>
          <input
            type="range"
            className={validationState.inputClasses('modern-range-slider')}
            name="saneScore"
            required
            min="0"
            max="100"
            step="1"
            value={values.saneScore || ''}
            onChange={(event) => handleFormData("sane", "saneScore", event.target.value)}
            aria-label={`${study === "elbow" ? "Elleboog" : "Schouder"} functieniveau beoordeling`}
            {...validationState.ariaProps}
          />
          <input
            type="number"
            className={validationState.inputClasses('modern-number-input')}
            name="saneScore"
            required
            min="0"
            max="100"
            step="1"
            value={values.saneScore || ''}
            onChange={(event) => handleFormData("sane", "saneScore", event.target.value.trim())}
            aria-label="Functieniveau score invoer"
            {...validationState.ariaProps}
          />
        </div>
        
      </div>
    </div>
  );
};

export default SANE;